import { BOOKINGS } from '../constants/actionTypes';

const initial = { items: [], total: 0, current: null, loading: false, error: null };

export default function bookingReducer(state = initial, action) {
  switch (action.type) {
    case BOOKINGS.LIST_REQUEST: return { ...state, loading: true, error: null };
    case BOOKINGS.LIST_SUCCESS: return { ...state, loading: false, items: action.payload.items, total: action.payload.total };
    case BOOKINGS.LIST_FAILURE: return { ...state, loading: false, error: action.payload };
    case BOOKINGS.GET_SUCCESS:  return { ...state, current: action.payload };
    default: return state;
  }
}
